export class UnsupportedCallingCodeError extends Error {
  name = 'UnsupportedCallingCode';
}
